module.exports = __webpack_public_path__ + "img/1243939195.9cb51fa3.jpg";